import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propStr } from '../../../helpers/custom-prop-types';
const SlideSearchFolderIcon = ({ className }) => (_jsx("svg", Object.assign({ className: `svg-slide-search-folder-icon ${className}`, height: '14.595', viewBox: '0 0 18 14.595', width: '18', xmlns: 'http://www.w3.org/2000/svg' }, { children: _jsx("path", { d: 'M.486,0h6L9.22,2.676h8.293A.486.486,0,0,1,18,3.162V14.108a.486.486,0,0,1-.486.486H.486A.486.486,0,0,1,0,14.108V.486A.486.486,0,0,1,.486,0Z', fill: '#a1a7b2' }) })));
SlideSearchFolderIcon.propTypes = {
    className: propStr(),
};
SlideSearchFolderIcon.defaultProps = {
    className: '',
};
export default SlideSearchFolderIcon;
